import { callKakaostyleMktFunction } from '../../callKakaostyleMktFunction';

export const logFacebook = (eventName: string, parameters?: object) => {
  callKakaostyleMktFunction('logFacebook', eventName)(parameters);
};
